import styled from 'styled-components';

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
`;

export const Icon = styled.img`
  :hover {
    cursor: pointer;
  }
`;
